import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { RepairabilityIndex as TRepairabilityIndex } from "./repairabilityIndex.types";

type RepairabilityIndexProps = {
    repairabilityIndex: TRepairabilityIndex;
};

export const RepairabilityIndex = ({
    repairabilityIndex
}: RepairabilityIndexProps) => {
    const { t } = useGranite();

    return (
        <div className={cn("tw:flex tw:mb-4")}>
            <img
                className={cn(
                    "tw:block tw:object-scale-down tw:object-left tw:max-w-full tw:h-18"
                )}
                src={repairabilityIndex.imageUrl}
                alt={repairabilityIndex.altText}
            />

            <div className={cn("tw:ml-4")}>
                <p className={cn("tw:mb-0")}>
                    {t("ecommerce.label.recoverabilityIndex.title")}
                </p>
                <a
                    className={cn(
                        "tw:block tw:text-sm tw:font-light tw:text-primary tw:cursor-pointer tw:hover:underline"
                    )}
                    href={repairabilityIndex.documentUrl}
                    target={"_blank"}
                    rel={"noopener"}
                >
                    {t("ecommerce.label.recoverabilityIndex.infoLink")}
                </a>
            </div>
        </div>
    );
};
